import { render, staticRenderFns } from "./POPDouble.vue?vue&type=template&id=6d72d410&scoped=true"
import script from "./POPDouble.vue?vue&type=script&lang=js"
export * from "./POPDouble.vue?vue&type=script&lang=js"
import style0 from "./POPDouble.vue?vue&type=style&index=0&id=6d72d410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d72d410",
  null
  
)

export default component.exports